import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioLabelGroupComponent } from './components/radio-label-group.component';
import { FormsModule } from '@angular/forms';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';

@NgModule({
  declarations: [RadioLabelGroupComponent],
  imports: [CommonModule, FormsModule, MatRadioModule],
  exports: [RadioLabelGroupComponent],
})
export class RadioLabelGroupModule {}
